import { render, staticRenderFns } from "./parts-list.vue?vue&type=template&id=08929812&scoped=true&"
import script from "./js/parts-list.js?vue&type=script&lang=js&"
export * from "./js/parts-list.js?vue&type=script&lang=js&"
import style0 from "./parts-list.vue?vue&type=style&index=0&id=08929812&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08929812",
  null
  
)

export default component.exports